"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immer = require("immer");

var _rxjs = require("rxjs");

var _scheduler = _interopRequireDefault(require("./scheduler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStore = function createStore() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? {
    experimentData: {}
  } : _ref$initialValue,
      reducer = _ref.reducer,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  var state = (0, _immer.freeze)(initialValue, true);
  var subject = new _rxjs.BehaviorSubject(state);
  var scheduled = subject.pipe((0, _scheduler.default)(options));

  var dispatch = function dispatch(action) {
    state = (0, _immer.produce)(state, function (draft) {
      return reducer(draft, action);
    });
    subject.next(state);
  };

  var subscribe = function subscribe(fn) {
    var subscriber = scheduled.subscribe(fn);

    var unsubscribe = function unsubscribe() {
      return subscriber.unsubscribe();
    };

    return unsubscribe;
  };

  return {
    dispatch: dispatch,
    subscribe: subscribe
  };
};

var _default = createStore;
exports.default = _default;